exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CuePopup-4f94811f{width:auto;width:200px}.CuePopup-4f94811f:before{content:'';display:inline-block;float:right;height:15px;width:15px}\n", ""]);

// Exports
exports.locals = {
	"CuePopup": "CuePopup-4f94811f"
};